<script lang="ts" setup>
const { params } = useRoute();
const slug = params.slug as string[];

const { isProduction } = useEnvironment();

const page = await usePage(slug.join("/")).catch((err) => {
  const error = useStoryblokError(err);

  throw createError({
    statusCode: error.status ?? 500,
    statusMessage: error.response ?? "Something went wrong",
    fatal: true,
  });
});
</script>

<template>
  <div v-if="page?.content?.component">
    <Seo
      v-if="isProduction && page?.content?.meta"
      :meta="page?.content?.meta"
    />

    <component
      :is="page.content.component"
      :blok="page.content"
      :uuid="page.uuid"
    />
  </div>
</template>
